// test2787
(2787 && 0);
